@switch (specificTemplateName) {
  @case (tableNamesEnum.NextOfKin) {
    <app-users-template
      [columnName]="columnName"
      [element]="element"
      [buttonFunctions]="buttonFunctions"
    ></app-users-template>
  }
  @case (tableNamesEnum.ReadReceipts) {
    <app-default-cell [columnName]="columnName" [element]="element"></app-default-cell>
  }
  @default {
    <app-profile-competence-template
      [columnName]="columnName"
      [element]="element"
      [urlForRouting]="urlForRouting"
    ></app-profile-competence-template>
  }
}
